import { constants } from 'day8-ui';
import moment from 'moment';

const { TYW_DESTINATION } = constants;

// Shared with tyw-content /deals/last-minute via day8-ui constants (single source, no drift).
export const LAST_MINUTE_MAX_SPOTS = constants.LAST_MINUTE?.MAX_SPOTS ?? 4;

export const EXTRAS = {
  HOSTESS_TYPE: 'hostess',
  ULTRA_TYPE: 'ultra',
  FOOD_DRINKS_TYPE: 'food-drinks',
  BVI_DONATION: 'bvi-donation',
  TRANSFER_TYPE: 'transfer',
  SEPARATE_TYPE: 'separate',
  MERCH_TYPE: 'merchandise',
  INCLUDE_ALL_GUESTS_TYPE: 'include-guests',
  COPY: {
    foodDrinks: {
      title: 'Drinks',
      description: 'Save the hassle and order your drinks to be delivered to your marina.',
      image: '/assets/public/img/extras/drinks_package.jpg',
      priceText: 'Deliciousness',
      addText: 'Add drinks'
    },
    hostess: {
      title: 'Host',
      description: 'Be treated to freshly prepared meals every day.',
      image: 'https://cdn.theyachtweek.com/assets/booking/extras_host.jpeg',
      priceText: 'Trained chef',
      addText: 'Add a host'
    },
    ultra: {
      title: 'VIP Ultra tickets',
      description: 'TYW VIP Tickets to Ultra.',
      image: '/assets/public/img/extras/ultra_tickets.jpg',
      priceText: 'International DJs',
      addText: 'Add ultra tickets'
    },
    merchandise: {
      title: 'Merchandise',
      description: 'Pick out some exclusive TYW merchandise to remember your trip.',
      image: 'https://wpassets.theyachtweek.com/wp-content/uploads/2024/05/Yacht-Week-Kape1612-1-scaled.jpg',
      priceText: '',
      addText: 'Add Merchandise'
    },
    transfer: {
      title: 'Airport transfers',
      description: 'Transfers from the airport to your new home',
      image: '/assets/public/img/extras/transfer.jpg'
    }
  },
  DRINKS_PACKAGE_PRICE: 850
};
EXTRAS.BOX_TYPES = [EXTRAS.HOSTESS_TYPE, EXTRAS.ULTRA_TYPE, EXTRAS.FOOD_DRINKS_TYPE, EXTRAS.TRANSFER_TYPE, EXTRAS.MERCH_TYPE];

export const PRODUCTS = {
  SKIPPER_ID: 5,
  HOSTESS_ID: 6,
  ULTRA_ID: 2,
  FOOD_DRINKS_ID: 1,
  YACHT_ID: 3,
  WRISTBAND_ID: 4,
  DISCOUNT_ID: 17,
  FEE_ID: 20,
  OTHER_ID: 21,
  NOMINATE_SKIPPER_ID: 13,
  NOMINATE_HOSTESS_ID: 14,
  MOORING_FEES: 28,
  HALF_BOARD_CLASSIC: 32,
  HALF_BOARD_PREMIUM: 26,
  HALF_BOARD_LUXURY: 27,
  HALF_BOARD_LUXURY_PLUS: 38,
  DRINKS_PACKAGE: 33,
  CABIN_ID: 9,
  REFUNDABLE_CABIN_DEPOSIT: 57
};

export const ACTIONS = {
  SUCCESS: 'success',
  UPDATE_WEEKS: 'UPDATE_WEEKS',
  UPDATE_YACHTS: 'UPDATE_YACHTS',
  UPDATE_PLAN_BOOKING: 'UPDATE_PLAN_BOOKING',
  UPDATE_WEEK_VOTE: 'UPDATE_WEEK_VOTE',
  UPDATE_CREW_RATIO: 'UPDATE_CREW_RATIO',
  UPDATE_PERSONNEL: 'UPDATE_PERSONNEL',
  ADD_COMMENT: 'ADD_COMMENT',
  UPDATE_CREW_MEMBER: 'UPDATE_CREW_MEMBER',
  CANCEL_PLAN: 'CANCEL_PLAN',
  UPDATE_LEAD_BOOKER: 'UPDATE_LEAD_BOOKER',
  UPDATE_TITLE: 'UPDATE_TITLE',
  UPDATE_DESTINATION: 'UPDATE_DESTINATION',
  UPDATE_PLAN: 'UPDATE_PLAN',
  BOOK_PLAN: 'BOOK_PLAN',
  CREATE_PLAN: 'CREATE_PLAN',
  UPDATE_ACTIVE_PLANS: 'UPDATE_ACTIVE_PLANS',
  UPDATE_PRICING: 'UPDATE_PRICING',
  UPDATE_IS_CREW: 'UPDATE_IS_CREW',
  UPDATE_JOIN_DATA: 'UPDATE_JOIN_DATA'
};

export const CREW_MEMBER = {
  MEMBER_STATUS: 'member',
  CREW_SKIPPER_STATUS: 'crew_skipper',
  OK_STATUS: 'ok',
  DELETED_STATUS: 'deleted',
  SKIPPER_TYPE: 'skipper',
  SEX_MALE: 'M',
  SEX_FEMALE: 'F'
};

export const ORDER = {
  PAID_STATUS: 'paid',
  EURO_CURRENCY: 'EUR',
  CLOSED_STATUS: 'closed'
};

export const PAYMENT = {
  PAID_STATUS: 'paid',
  PENDING_STATUS: 'pending',
  FINANCE_PENDING_STATUS: 'finance-pending',
  SCHEDULED_STATUS: 'scheduled'
};

export const PAYLINK = {
  CANCELLED_STATUS: 'cancelled'
};

export const STAFF = {
  HOSTESS_TYPE: 'hostess',
  ASSIGNED_STATUS: 'assigned'
};

export const COUNTRYEMOJIS = {
  GREECE: '🇬🇷',
  CROATIA: '🇭🇷',
  ITALY: '🇮🇹',
  MONTENEGRO: '🇲🇪',
  BAHAMAS: '🇧🇸',
  STLUCIA: '🇱🇨',
  MARTINIQUE: '🇲🇶',
  FRANCE: '🇫🇷',
  FRENCHPOLYNESIA: '🇵🇫' // Tahiti
};

export const DESTINATION = {};

DESTINATION.NOT_WIFI = [
  TYW_DESTINATION.TAHITI,
  TYW_DESTINATION.YNF_TAHITI,
  TYW_DESTINATION.YNF_PC_TAHITI,
  TYW_DESTINATION.BVI,
  TYW_DESTINATION.BVI_CNCT,
  TYW_DESTINATION.YNF_PC_BVI,
  TYW_DESTINATION.YNF_SALT_ESCAPES_BVI,
  TYW_DESTINATION.ST_LUCIA_MARTINIQUE,
  TYW_DESTINATION.YACHTNIK_MART_ST_LUCIA,
  TYW_DESTINATION.MONTENEGRO,
  TYW_DESTINATION.YNF_PC_MONTENEGRO,
  TYW_DESTINATION.BAHAMAS,
  TYW_DESTINATION.YNF_PC_ANTIGUA,
  TYW_DESTINATION.YNF_PC_USVI,
  TYW_DESTINATION.TURKEY,
  TYW_DESTINATION.SARDINIA,
  TYW_DESTINATION.GREECE_BOOTCAMP,
  TYW_DESTINATION.SARDINIA_OVER_40,
  TYW_DESTINATION.ITALY
];

export const WEEK_ADDRESS_BOOKS = {

};

export const DESTINATION_PRICE_FROM_DEFAULTS = {
  // IF YOU UPDATE THESE, DON'T FORGET TO
  // ALSO UPDATE IN D8 REPO IN /constants.js
  1: 600, // CROATIA_ORIGINAL
  2: 556, // GREECE
  3: 750, // BVI
  5: null, // ITALY
  11: 959, // CROATIA_ULTRA
  21: 856, // MONTENEGRO
  24: 492, // CROATIA_DUBROVNIK
  25: null, // GREECE_REVIVE
  27: 1350, // SARDINIA (updated from 850 when cabins but not yachts were on sale)
  28: 1090, // TAHITI
  34: 675, // CROATIA_HIDEOUT
  43: 755, // ST LUCIA MARTINIQUE
  44: 775 // BAHAMAS
};

export const BOOKING = {
  NORMAL_TYPE: 'normal',
  GROUP_TYPE: 'group',
  CABIN_YACHT_TYPE: 'cabin',
  STANDARD_YACHT_TYPE: 'standard',
  REQUIRED_STAFF_CAPACITY_ADJUSTMENT: 1,
  PENDING_STATUS: 'pending',
  OK_STATUS: 'ok',
  DEFERRED_STATUS: 'deferred',
  PLAN_STATUS: 'plan',
  CHARTER_STATUS_CONFIRMED: 'booking_confirmed',
  YACHT_SUBJECT: 'yacht',
  CABIN_SUBJECT: 'cabin',
  SOLO_SUBJECT: 'solo'
};

export const YACHT = {
  HULLTYPE_MONOHULL: 'monohull',
  HULLTYPE_CATAMARAN: 'catamaran',
  SUNLOFT: 'sunloft'
};

export const CABIN = {
  SOLO_TYPE: 'solo',
  CABIN_TYPE: 'cabin'
};

export const CABIN_WEEK_STATUS = {
  STATUS_ACTIVE: 'active',
  STATUS_INACTIVE: 'inactive',
  STATUS_SOLD_OUT: 'sold_out'
};

// Ultra weeks correct for 2021
export const WEEK = {
  OPEN_STATUS: 'open',
  CLOSED_STATUS: 'closed',
  PREBOOKING_STATUS: 'prebooking',
  SOLD_OUT_STATUS: 'sold_out',
  INVISIBLE_STATUS: 'invisible',
  DELETED_STATUS: 'deleted',
  COMING_SOON_STATUS: 'coming_soon',
  YACHTNIK: 668,
  ULTRA: {
    2020: {
      ULTRA_FRIDAY: 27,
      ULTRA_WEEKEND: 28
    }
  }
};
WEEK.ULTRA_WEEKS = {
  2020: [WEEK.ULTRA[2020].ULTRA_FRIDAY, WEEK.ULTRA[2020].ULTRA_WEEKEND]
};

export const SKIPPER_PRICE_FALLBACK = 0;
export const HOST_PRICE_FALLBACK = 75000;

export const PACKAGES = {
  CLASSIC: 1,
  PREMIUM: 2,
  LUXURY: 3,
  LUXURY_PLUS: 4,
  CLASSIC_MONO: 5,
  CLASSIC_CAT: 6,
  PREMIUM_MONO: 7,
  PREMIUM_CAT: 8,
  SHARED_TRIPLE_ROOM: 9,
  SHARED_DOUBLE_ROOM: 10,
  SINGLE_ROOM: 11,
  SHARED_2_PERSON_SUITE: 12
};

export const STANDARD_YACHT = {
  OPEN_STATUS: 'open',
  CLOSED_STATUS: 'closed',
  INVISIBLE_STATUS: 'invisible',
  CLASSIC_RATING: PACKAGES.CLASSIC,
  PREMIUM_RATING: PACKAGES.PREMIUM,
  LUXURY_RATING: PACKAGES.LUXURY,
  LUXURY_PLUS_RATING: PACKAGES.LUXURY_PLUS
};

export const STANDARD_YACHT_ITEM = {
  mystery: true,
  id: 0,
  hullType: 'Monohull',
  size: 46,
  cabins: 4,
  productionYear: 'Newer than 2012',
  maxPersons: 9,
  deposit: 'TBC',
  marina: {
    name: 'Assigned 2 weeks prior to arrival',
    info: 'Split Airport is the best airport to fly in to regardless of marina'
  },
  boat: {
    rating: 'Classic',
    ratingId: 2,
    year: ' 2013 or newer',
    heads: 'Min. 2',
    size: '43-48',
    wifi: null,
    doubleCabins: 4,
    bunkCabins: 0,
    cabins: 4,
    saloonSpots: 2,
    skipperCabinSpots: 0,
    capacity: 10,
    hullType: 'monohull',
    type: 'Classic Yacht',
    id: 575,
    name: 'Bavaria 46',
    attributes: [],
    images: [
      '/img/yacht/4704_cr46-exterior_03.jpeg',
      '/img/yacht/4707_852-110907.jpeg',
      '/img/yacht/4708_c46-7.jpeg',
      '/img/yacht/4705_3250-4b.jpeg',
      '/img/yacht/4706_c46-18.jpeg'
    ]
  }
};

export const STANDARD_YACHT_ITEM_REVIVE = {
  ...STANDARD_YACHT_ITEM,
  marina: {
    name: 'Assigned 2 weeks prior to arrival',
    info: 'Athens Airport is the best airport to fly in to regardless of marina'
  },
  boat: {
    ...STANDARD_YACHT_ITEM.boat,
    rating: 'Premium',
    ratingId: 3,
    year: ' 2011 or newer',
    size: '43-53',
    type: 'Premium Yacht'
  }
};

export const STANDARD_YACHT_ITEM_INVISIBLE = {
  ...STANDARD_YACHT_ITEM,
  boat: {
    ...STANDARD_YACHT_ITEM.boat,
    year: ' 2011 or newer'
  }
};

export const PLAN = {
  YACHT_CATEGORIES: {
    1: { name: 'Economy', ratingId: 1, yachts: [] },
    2: { name: 'Classic', ratingId: 2, yachts: [] },
    3: { name: 'Premium', ratingId: 3, yachts: [] },
    4: { name: 'Luxury', ratingId: 4, yachts: [] }
  },
  STANDARD_YACHT_CATEGORIES: {
    2: { name: 'Classic', ratingId: 2, yachts: [] },
    3: { name: 'Premium', ratingId: 3, yachts: [] },
    4: { name: 'Luxury', ratingId: 4, yachts: [] }
  },
  PRICING: {
    FOOD_PACKAGE: 'food & drinks package',
    DRINKS_PACKAGE: 'drinks package',
    HOST_FOOD_PACKAGE: 'host food & drinks package',
    SKIPPER: 'skipper',
    HOST: 'host',
    EXTRAS: 'extras',
    YACHT: 'yacht',
    NON_VARIABLE_EXTRAS: 'nonVariableExtras'
  }
};

export const PREFERENCES = {
  EMAIL_PLANNER_COMMENTS: 'planComments',
  EMAIL_NEWSLETTER: 'news'
};

export const ORDINALS = {
  1: '1st',
  2: '2nd',
  3: '3rd'
};

export const YACHTS = {
  1: 'Economy',
  2: 'Classic',
  3: 'Premium',
  4: 'Luxury'
};

export const DEFAULT_GUEST_COUNT = 8;

export const SURVEY = {
  ID: 1,
  DAYS_BEFORE_EVENT_AVAILABLE: 70
};

export const PARTNERS = {
  DREAM_YACHT_CROATIA: 69,
  DREAM_YACHT_GREECE: 74
};

export const WEEK_URGENCY_YACHT_LIMIT = 4;

export const CREW = {
  MAX_GUESTS: 12,
  MAX_GUESTS_ALLOWED_ON_CABIN_BOOKING: 4,
  TYPE_MEMBER: 'member',
  TYPE_HOST: 'hostess',
  TYPE_SKIPPER: 'skipper'
};

export const MORE_YACHTS_ADDED_WEEK_IDS = [
  1263,
  1264
];

export const CAPACITY = {
  MIN: 7,
  MAX: CREW.MAX_GUESTS
};

export const CHECKOUT_TIMER_IN_MINUTES = 15;

export const COMPANIES = {
  DAY8: 2,
  YNF: 4
};

export const PRICE_VISIBILITY = {
  HIDDEN: 'hidden',
  PARTIAL: 'partial',
  FULL: 'full'
};

export const ROUTES = {
  SIGNATURE_ROUTE: 'SG',
  CLASSIC_ROUTE: 'CS',
  PRIVATE_CHARTER_ROUTE: 'PC'
};

export const FILTERS = {
  HULL_TYPE: 'hullType',
  MIN_CAPACITY: 'minCapacity',
  MAX_CAPACITY: 'maxCapacity',
  MARINA: 'marina',
  AMENITIES: 'amenities',
  WEEK: 'weekFilter',
  WEEK_CONFIRM: 'weeks',
  DESTINATION: 'destinationFilter',
  DESTINATION_CONFIRM: 'dest',
  YEAR: 'yearFilter',
  YEAR_CONFIRM: 'year',
  BOAT_YEAR: 'boatYear',
  BOAT_CABINS: 'boatCabins',
  BOAT_SIZE: 'boatSize',
  MIN_PRICE: 'minPrice',
  MAX_PRICE: 'maxPrice',
  EXTRAS: 'extras',
  FAVOURITES: 'favourites',
  BOYS: 'boys',
  GIRLS: 'girls',
  HOST: 'hostess',
  CABIN_BOOKING_TYPE: 'cabinBookingType',
  PACKAGE: 'packageFilter',
  COUNTRY: 'countryFilter',
  FESTIVAL: 'festivalFilter',
  LAST_MINUTE: 'lastMinute',
  DEALS: 'deals'
};

export const EXTERNAL_SKIPPER_YACHT_IDS = [
  4069,
  4116,
  4104
];

export const TIER_1_PRICE_END_DATE = new Date('2023-02-16 23:59:59');

export const TIER_1_PRICE_COUNTRIES = moment.utc(TIER_1_PRICE_END_DATE).isBefore() ? [] : [
  'Croatia',
  'Turkey',
  'Greece'
];

export const IGNORE_CROSS_SELL_DESTINATION_IDS = [DESTINATION.CROATIA_MBA_ROUTE];

export const YACHT_SORTING_OPTIONS = [
  { value: 1, label: 'Recommended' },
  { value: 2, label: 'Price: low - high' },
  { value: 3, label: 'Price: high - low' },
  { value: 4, label: 'Yacht age: new - old' },
  { value: 5, label: 'Yacht age: old - new' }
];

export const SORT_BOOKING_OPTIONS = [
  { value: 1, label: 'Recommended' },
  { value: 2, label: 'Price: low - high' },
  { value: 3, label: 'Price: high - low' }
];